
import Heading from "./Heading";
import { service2, service3 } from "../assets";
import { brainwaveServicesIcons } from "../constants";
import { VideoChatMessage } from "./design/Services";
import Generating from "./Generating";
import ActionBtn from "./Button/ActionBtn";
const Services = () => {
	return (
		<div className="mt-20">
		<div className="container mx-auto px-4 text-white" style={{ overflowX: 'hidden' }}>
				<Heading
					title="Futeur Intelligence ™"
					text ="Revolutionizing Business Intelligence for Small Businesses."
				
				/>

	{/* First Service Block */}
<div
className="
	relative
	z-[1]
	flex 
	flex-col                      /* Stack vertically on small screens */
	md:flex-row                  /* Horizontal layout from md: */
	items-center
	h-auto                       /* Let height be auto on mobile */
	md:h-[39rem]                 /* Original height from md */
	mb-5
	p-4                          /* Less padding on mobile */
	md:p-8                       /* Original padding on md */
	border 
	border-black 
	rounded-3xl
	overflow-hidden 
	lg:p-20 
	xl:h-[46rem]
"
>
{/* 1. Video Container */}
<div
	className="
		relative
		w-full
		h-[400px]                 /* A smaller fixed height on mobile just so you see the video */
		overflow-hidden
		pointer-events-none
		mb-2

		/* Switch to absolute background for md+ */
		md:absolute
		md:top-0
		md:left-0
		md:w-3/5
		md:h-full
		xl:w-auto

		/* Order: Always first (1) on both mobile and md+ */
		order-1
		md:order-1
	"
>
	<video
		className="
			w-full
			h-full
			object-cover
			md:object-right
		"
		width={1920}
		height={1080}
		src="/ai.mp4"
		alt="Generative AI visual representation"
		autoPlay
		loop
		muted
		playsInline
	/>
</div>

{/* 2. Generating Component */}
<Generating
	className="
		/* On small screens: 2nd in order */
		order-3

		/* On md screens and up: 3rd in order */
		md:order-2

		/* Absolute positioning for the large layout */
		absolute
		left-4
		right-4
		mt-10
		bottom-4
		border-n-1/10
		border
		lg:left-1/2
		lg:right-auto
		lg:bottom-8
		lg:-translate-x-1/2
	"
/>

{/* 3. Glass-like Box */}
<div
	className="
		relative
		z-[1]
		max-w-[20rem]
		p-4
		bg-black/30
		backdrop-blur-lg
		rounded-xl
		shadow-lg
		mb-40
		/* On small screens: 3rd in order */
		order-3
		
		/* On md and up: 2nd in order */
		md:order-2

		mt-4            /* space on mobile */
		md:ml-auto
		md:mt-0
	"
>
	<h4 className="h4 text-3xl mb-4 text-bold text-white">Powered By AI</h4>
	<p className="text-2xl mb-[2rem] text-white">
		What if your business could see the future?
	</p>
	<p className="text-gray-300 text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed">
		Futeur Intelligence, powered by cutting-edge AI, unlocks real-time analytics,
		forecasts growth opportunities, and ensures survival feasibility. Harness
		unconventional data streams—social trends, economic indicators, and more—to
		make smarter, faster decisions.
	</p>
	<p className="text-gray-300 text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed">
		Designed for small businesses, Futeur Intelligence combines precision and
		practicality to empower your journey toward profitability and resilience.
	</p>
		
</div>
</div>

					{/* Second Service Block */}
					<div className="relative z-1 grid gap-5 lg:grid-cols-2">
						{/* Photo Editing */}
						<div className="relative min-h-[39rem] border border-black rounded-3xl overflow-hidden">
							<div className="absolute inset-0">
								<img
									src={service2}
									className="h-full w-full object-cover"
									width={630}
									height={750}
									alt="Safe and Secure"
								/>
							</div>

							<div className="absolute inset-0 flex flex-col justify-end p-8 bg-gradient-to-b from-n-8/0 to-n-8/90 lg:p-15">
							<h4 className="h4 mb-4 text-bold text-white">Revolutionizing Data Security</h4>
								<p className="text-gray-300 text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed">
								We’ve redefined data protection with a Decentralized Data Security Framework (DDSF) that sets a new global benchmark. By harnessing the power of distributed databases, quantum-resistant encryption, and zero-trust architecture, we ensure your confidential data is not only secure but impenetrable.</p> 
							</div>
						</div>

						{/* Video Generation */}
						<div className="p-4 bg-n-7 rounded-3xl overflow-hidden lg:min-h-[46rem]">
							<div className="py-12 px-4 xl:px-8">
							<h4 className="h4 mb-4 text-bold text-white">Easy-To-Use</h4>
								<p className="text-gray-300 text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed">
									We've streamlined our platform to be as sleek and user-friendly as your go-to smartphone. Say farewell to complexity and embrace simplicity – navigating our platform is as effortless as sending a text message. Because we understand that for small businesses, building credit should be straightforward and stress-free.
								</p>

								<ul className="flex items-center justify-between">
									{brainwaveServicesIcons.map((item, index) => (
										<li
											key={index}
											className={`flex items-center justify-center ${
												index === 2
													? "w-[3rem] h-[3rem] p-0.25 bg-conic-gradient md:w-[4.5rem] md:h-[4.5rem]"
													: "w-10 h-10 bg-n-6 md:w-15 md:h-15"
											} rounded-2xl`}
										>
											<div
												className={
													index === 2
														? "w-full h-full bg-n-7 rounded-[1rem]"
														: ""
												}
											>
												<img src={item} width={24} height={24} alt="Service Icon" />
											</div>
										</li>
									))}
								</ul>
							</div>

							<div className="relative h-[20rem] bg-n-8 rounded-xl overflow-hidden md:h-[25rem]">
								<img
									src={service3}
									className="w-full h-full object-cover"
									width={520}
									height={400}
									alt="Easy-To-Use"
								/>

								<VideoChatMessage />
							</div>
						</div>
					</div>

				</div>
		</div>
		
	);
};

export default Services;

